/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

const CUSTOM_API_TOKEN = process.env.NEXT_PUBLIC_CUSTOM_API_TOKEN_REQUEST_STRING;
const MSAL_CLEINT_ID = process.env.NEXT_PUBLIC_MSAL_CLEINT_ID;
const MSAL_AUTHORITY = process.env.NEXT_PUBLIC_MSAL_AUTHORITY;
const MSAL_REDIRECT_URL = process.env.NEXT_PUBLIC_MSAL_REDIRECT_URL;

// eslint-disable-next-line unused-imports/no-unused-vars
export const msalConfig = (redirectUri?: string) => ({
    auth: {
        clientId: MSAL_CLEINT_ID || '', // This is the ONLY mandatory field that you need to supply.
        authority: MSAL_AUTHORITY || '', // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        postLogoutRedirectUri: MSAL_REDIRECT_URL || '',
        navigateToLoginRequestUrl: false,
        redirectUri: redirectUri || MSAL_REDIRECT_URL || '',
    },
    cache: {
        cacheLocation: 'localStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        return;
                    case LogLevel.Verbose:
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        break;
                    default:
                }
            },
        },
    },
    loadFrameTimeout: 30000,
    iframeHashTimeout: 30000,
});

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ['User.ReadBasic.All'],
};

export const customAPITokenRequest = {
    scopes: [CUSTOM_API_TOKEN || ''],
};
